import React from 'react';
import { CaseTimelineTabMain } from "../settingModule/CaseTimeline";

const SettingMain = (props) => {
    return (
        <CaseTimelineTabMain {...props} />
    );
};

export default SettingMain;